<template>
  <!-- 视频公用组件 -->
  <div class="video-box" :class="{activeDelete: isDelect,indexVideoBox:indexClass}">
    <div class="video-play">
      <img :src="imgUrl" alt="" class="video-img" @click="goGroupDetail(videoItem)">
      <div class="video-box">
        <img
          @click="goGroupDetail(videoItem)"
          src="../../assets/img/common-img/play-icon.png"
          alt=""
          class="play-icon"
        >
        <!-- <div class="video-recoder" v-show="isHistory"> -->
        <div class="video-recoder" v-show="false">
          <p class="recoder-text" v-if="!videoItem.finish === true">观看至</p>
          <p class="recoder-text" v-if="!videoItem.finish === true">第{{VideoFinish}}集</p>
          <span class="recoder-text" v-if="videoItem.finish === true">已看完</span>
        </div>
        <!-- <p class="video-name">{{imgTitle}}</p> -->
        <!-- <img src="../../assets/img/common-img/video-top-shdow@2x.png" alt="" class="top-shdow"> -->
        <img src="../../assets/img/common-img/fengmian-bgc.png" alt="" class="top-shdow">
      </div>
    </div>
    <div class="video-detail">
      <div class="video-top">
        <span class="video-title">{{ videoItem.group_name }}</span>
        <van-button @click="goAsk(item)" class="ask-online" v-if="!inMiniProgram">在线咨询</van-button>
      </div>
      <div class="desc-bg">
        <span class="group-desc line2">{{imgTitle}}</span>
      </div>
      <!-- <ul class="video-tips">
        <span class="class-name">症状</span>
        <li
          @click="goSearch('/SdSearch',item.symptom_name)"
          class="tips-text"
          v-if="index<2"
          v-for="(item,index) in videoItem.zz"
          :key="index"
        >
          <span>{{item.symptom_name || '暂无'}}</span>
        </li>
      </ul>-->
      <!-- <div class="video-bottom left">
        <span class="class-name group">选集</span>
        <div class="select-video-item-box-wrap">
          <div class="select-video-item-box">
            <template v-for="(item, iIndex) in videoItem.spjh">
              <div
                @click="goDetail(item.item_id, iIndex)"
                class="select-video-item"
                :class="[computedVideoItemClass(item)]"
              >
                {{ item.tag_name.split('-')[1] }}
                <img
                  v-if="item.issf == '1' && !item.jf"
                  src="@/assets/img/videoDetail/lock2.png"
                  alt=""
                  class="lock-logo"
                >
              </div>
            </template>
            <div class="blank"></div>
          </div>
        </div>
      </div>-->
    </div>
    <!-- <div class="content-box-1">
      <div class="video-name-box">
        <span class="video-name">{{videoItem.spjh[0].tag_name}}</span>
        <div class="more-box" :class="{noButtonFlag:videoItem.group_name!=='重症手足口病'}">
          <span class="name-tips" :class="{tipsActive:isShowTips}">{{videoItem.summary}}</span>
          <img src="../../assets/img/see-doctor-icon/1-3jianjiexiala@2x@2x.png" alt="" class="more-icon" @click.stop="isShowTips = !isShowTips">
        </div>
        <van-button v-if="videoItem.group_name === '重症手足口病'" @click="goInsurance" type='primary' class="go_insurance">点我，给宝宝提供健康保障</van-button>
      </div>
      <div class="select-box border-css">
        <div class="select-title">
          <span class="title-text">视频选集</span>
          <span class="title-tips" >{{videoItem.pub_date}} {{videoItem.episode_text}}</span>
        </div>
        <div class="select-video-item-box-wrap">
          <div class="select-video-item-box">
            <template v-for="(item, iIndex) in videoItem.spjh">
              <div
                @click="goDetail(item.item_id, iIndex)"
                class="select-video-item"
                :class="[computedVideoItemClass(item)]" >
                {{ item.tag_name.split('-')[1] }}
                <img v-if="item.issf == '1' && !item.jf" src="@/assets/img/videoDetail/lock2.png" alt="" class="lock-logo">
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
  import iMp from "@/common/isMp";
  export default {
    data() {
      return {
        videoItem: {},
        isHistory: false,
        imgUrl: "",
        imgTitle: "",
        VideoFinish: "",
        indexClass: false,
        isShowTips: true
      };
    },
    mixins: [iMp],
    props: {
      item: {
        type: Object
      },
      isDelect: {
        type: Boolean
      }
      // departmentId: {
      //   type: String
      // }
    },
    created() {},
    mounted() {
      this.indexClass = this.$route.path === "/SdSeeDoctor";
    },
    watch: {
      item(n, o) {
        this.videoItem = n;
        this.fetchVideo(n);
      }
    },
    // imgUrl  imgTitle  VideoFinish(如果没看完就进入view ) view.order_num 最大集数
    beforeMount() {
      this.videoItem = this.item;
      if (this.$route.path === "/SdVideoHistory") {
        this.isHistory = true;
        if (this.videoItem.finish === true) {
          this.VideoFinish = "已看完";
        }
        // else {
        //   this.VideoFinish = this.videoItem.view.order_num;
        // }
      }
      this.imgUrl = this.videoItem.image; // aliyun_cover_url
      this.imgTitle = this.videoItem.describe;
    },
    methods: {
      computedVideoItemClass(item) {
        const issf = item.issf; // 是否需要购买 1 : 要收费 2. 不用收费
        const jf = item.jf; // 是否buy
        // if( issf == '1' && jf && this.activeIndex == item.item_id ) {
        //   return 'active'
        // }
        // else if( issf == '2' && this.activeIndex == item.item_id ) {
        //   return 'active'
        // }
        if (issf == "1" && !jf) {
          return "lock";
        }
        return "";
      },
      goDetail(itemId) {
        this.$router.push({ path: "/SdDetailVideo", query: { itemId: itemId } });
      },
      // 相关专题(相关视频)
      goGroupDetail(val) {
        this.$router.push("/SdGroupDetail?itemId=" + val.item_id);
        // 由于跳转的是当前页面，this.$router.push不会更新当前组件
        // location.reload();
        // this.fetch() //直接监听路由
      },
      fetchVideo(val) {
        this.videoItem = val;
        if (this.$route.path === "/SdVideoHistory") {
          this.isHistory = true;
          if (this.videoItem.finish === true) {
            this.VideoFinish = "已看完";
          }
          // else {
          //   this.VideoFinish = this.videoItem.view.order_num;
          // }
        }
        // else {
        //   // this.imgUrl = this.videoItem.aliyun_cover_url;
        //   // this.imgTitle = this.videoItem.long_name;
        // }
        this.imgUrl = this.videoItem.image;
        this.imgTitle = this.videoItem.describe;
      },
      goSearch(val, query) {
        this.$router.push({ path: val, query: { key: query } });
        this.$root.$emit("key", query);
      },
      goAsk(val) {
        if (val.department_id) {
          this.$router.push({
            path: "/SdAskDoctor",
            query: {
              department_id: val.department_id,
              name: val.title
            }
          });
        } else {
          this.$router.push({
            path: "/SdAskDoctor",
            query: {
              department_id: val.classify[0].department_id,
              name: val.classify[0].title
            }
          });
        }
      }
    }
  };
</script>

<style lang="postcss">
  .video-box {
    width: 100%;
    font-family: "SourceHanSansCN-Medium";
    font-size: 28px;
    color: #fff;
    // box-sizing: border-box;
    overflow: hidden;
    /* border: 1px solid #fff; */
    // border-radius: 10px;
    // margin: 0 30px;
    /* box-shadow: 1px 8px 8px rgba(0,0,0,0.08); */
    & .video-play {
      width: 100%;
      height: 300px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      & .video-img {
        width: 100%;
        position: absolute;

        /* border-radius: 10px; */
      }
      & .video-box {
        display: flex;
        justify-content: center;
        align-items: center;
        /* width: 100%; */
        height: 100%;
      }
      & .play-icon {
        width: 100px;
        height: 100px;
        z-index: 888;
        position: absolute;
        right: 50%;
        margin-right: -50px;
        top: 50%;
        margin-top: -50px;
      }
      & .video-recoder {
        height: 98px;
        width: 98px;
        border-radius: 50%;
        /* border: 3px solid #37bd19; */
        border: 3px solid #37bd19;
        position: absolute;
        background: rgba(0, 0, 0, 0.5);
        font-family: "SourceHanSansCn Regular";
        font-size: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        right: 30px;
        bottom: 30px;
        & .recoder-text {
          text-align: center;
        }
      }
      & .video-name {
        font-size: 36px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 40px;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
        position: absolute;
        top: 21px;
        left: 25px;
        width: 95%;
        z-index: 998;
        left: 30px;
        display: -webkit-box;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      & .top-shdow {
        position: absolute;
        top: 0px;
        left: 0;
        z-index: 1;
        height: 100px;
        width: 100%;
        z-index: 555;
        /* opacity: 0.2; */
      }
    }
    & .video-detail {
      margin: 0 30px;
      margin-top: 30px;
      & .video-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        & .video-title {
          font-family: "SourceHanSansCN-Bold";
          font-size: 36px;
          color: #333;
          font-weight: bold;
        }
        & .ask-online {
          /* width: 150px; */
          height: 44px;
          line-height: 44px;
          background: rgba(55, 189, 25, 1);
          border-radius: 22px;
          font-size: 28px !important;
          color: #fff;
          font-family: "SourceHanSansCN-Medium";
          box-shadow: 0px 3px 6px 0px rgba(55, 189, 25, 0.5);
          & span.van-button__text {
            font-size: 22px;
            float: left;
          }
        }
      }
      & .desc-bg {
        padding: 30px 0;
        & .line2 {
          display: -webkit-box;
          text-overflow: ellipsis;
          /* 不用以下注释安卓机就用不了 */
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
          overflow: hidden;
          -webkit-line-clamp: 2;
        }
        & .group-desc {
          font-size: 24px;
          line-height: 36px;
          color: rgba(102, 102, 102, 1);
        }
      }
      & .class-name {
        font-family: "Source Han Sans CN";
        color: #999;
        font-size: 29px;
        width: 70px;
        &.group {
          margin-top: -26px;
        }
      }
      & .video-tips {
        display: flex;
        margin: 30px 0;
        align-items: center;
        & .tips-text {
          padding: 0 10px;
          height: 36px;
          border: 1px solid rgba(48, 116, 122, 1);
          border-radius: 8px;
          color: #30747a;
          font-size: 22px;
          display: flex;
          justify-content: center;
          align-items: center;
          /* margin: 0 30px; */
        }
      }
      & .video-tips li:nth-child(2) {
        color: #af5531;
        border: 1px solid #af5531;
        margin: 0 20px;
        margin-left: 12px;
      }
      & .video-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100vw;
        padding-left: 30px;
        &.left {
          margin-left: -30px;
        }
        & .video-select::-webkit-scrollbar {
          display: none;
        }
        & .scroll-box {
          width: 100%;
          overflow: hidden;
        }
        & .video-select {
          padding: 20px;
          margin: -20px;
          color: #333;
          font-family: "SourceHanSansCN-Regular";
          display: flex;
          align-items: center;
          display: -webkit-box;
          overflow-x: scroll;
          -webkit-overflow-scrolling: touch;
          /* width: 100%; */
          font-size: 32px;
          text-align: center;
          & .select-num {
            height: 60px;
            width: 70px;
            background-color: #e5e5e5;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 20px;
            border-radius: 10px;
          }
        }
        & .video-select li:last-child {
          /* color: #37bd19; */
        }
        & .share-video {
          width: 38px;
          height: 38px;
          margin-left: 10px;
        }
      }
    }

    & .video-name-box {
      margin-top: 30px;
      /* & .video-name {
            font-size: 36px;
            font-family: SourceHanSansCN-Bold;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
          } */
      & .video-name {
        font-family: SourceHanSansCN-Bold;
        font-weight: bolder;
      }
      & .more-box {
        display: flex;
        justify-content: space-between;
        font-size: 24px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-top: 25px;
        padding-bottom: 50px;
        /* align-items: center; */
        & .name-tips {
          line-height: 35px;
          margin-right: 27px;
        }
        & .tipsActive {
          /* height: 35px; */
          display: -webkit-box;
          text-overflow: ellipsis;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
          overflow: hidden;
          -webkit-line-clamp: 1;
        }
        & .more-icon {
          width: 20px;
          height: 12px;
          margin-top: 3px;
          padding: 10px;
        }
      }
      & .noButtonFlag {
        border-bottom: 1px solid rgba(215, 215, 215, 1);
      }
      & .go_insurance {
        width: 100%;
        height: 54px;
        border-radius: 50px;
        font-size: 30px;
        font-family: "SourceHanSansCN-Medium";
      }
    }
    & .select-video-item-box-wrap {
      font-size: 0;
      width: 780px;
      height: 100px;
      overflow-y: hidden;
      margin-left: 22px;
      margin-bottom: 30px;
      & .select-video-item-box {
        overflow-x: auto;
        white-space: nowrap;
        padding-bottom: 25px;
        & .blank {
          height: 100%;
          width: 30px;
          display: inline-block;
        }
        & .select-video-item {
          display: inline-block;
          min-width: 150px;
          //height: 140px ;
          line-height: 1;
          padding-top: 36px;
          padding-bottom: 38px;
          text-align: center;
          color: #333;
          font-size: 26px;
          background-color: #e5e5e5;
          border-radius: 10px;
          margin-right: 20px;
          position: relative;
          &.lock {
            background-color: #f2f2f2;
            color: #999;
          }
          &.active {
            color: #76ff00;
            background-color: #454545;
          }
          & .lock-logo {
            width: 25px;
            position: absolute;
            right: 12px;
            top: 10px;
          }
        }
      }
    }

    & .content-box-1 {
      padding: 0 30px;
      background-color: #fffffd;
      width: 100%;
      box-sizing: border-box;
      pointer-events: auto;
      /* height: 100%; */
      /* padding-top: 430px; */
      /* border-top:1px solid rgba(215,215,215,1); */
    }
  }
  .indexVideoBox {
  }
  .activeDelete {
    box-shadow: 1px 8px 8px rgba(0, 0, 0, 0.08);
  }
</style>



// WEBPACK FOOTER //
// src/components/public/VideoBox.vue